/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ inviterName: NonNullable<unknown>, company: NonNullable<unknown> }} Signup_Invitation_BannerInputs */

const es_co2_signup_invitation_banner = /** @type {(inputs: Signup_Invitation_BannerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.inviterName} te invitó a unirte a ${i?.company}.`)
};

/**

* @param {Signup_Invitation_BannerInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_invitation_banner = /** @type {((inputs: Signup_Invitation_BannerInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Invitation_BannerInputs, { locale?: "es-CO" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_invitation_banner(inputs)
});